import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Header from '../Components/Header/page';
import Footer from '../Components/Footer/Footer';
import axios from 'axios';


const Barbers = () => {

    const [data, setData] = useState([])

    useEffect(() => {
        axios
          .get("https://api.kazbarber.com/api/barbers")
          .then((response) => {
            console.log(response.data, 'barber');
            setData(response.data);
          })
          .catch((error) => {
            console.error('Error fetching barber data:', error);
          });
      }, []);
    return (
        <>
        <Header />
            <section id="ourbarbar" className="our-team m-300">
                <div class="container">
                    <div className="row">
                        <h2 class="heading-title">Our Barbar</h2>
                        {data?.data?.map((e) => {
                            return (
                                <>
                                    <div className='col-lg-3'>
                                        <Link to={`/detail/${e?.id}`}>
                                            <div class="our-team-inner">
                                                <div class="our-team-img">
                                                    <img src={e?.image} alt="" />
                                                </div>
                                                <div class="our-team-text">
                                                    <h5>{e?.fname}{e?.lname}</h5>
                                                    <span>Barber</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </>
                            )
                        })}

                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}




export default Barbers